/* RESPONSIBLE TEAM: team-inbox-experience */
import { type RenderableData } from 'embercom/objects/inbox/renderable-data';
import { RenderableType } from 'embercom/models/data/inbox/renderable-types';
import { EntityType } from 'embercom/models/data/entity-types';
import AdminSummary, { type AdminSummaryWireFormat } from '../admin-summary';
import CustomBotSummary, {
  type CustomBotSummaryWireFormat,
} from 'embercom/objects/inbox/custom-bot-summary';
import { Upload, type UploadWireFormat } from 'embercom/objects/inbox/renderable/upload';

interface BotNoteWireFormat {
  renderable_type: RenderableType;
  blocks: Array<object>;
  entity: AdminSummaryWireFormat;
  custom_bot_summary?: CustomBotSummaryWireFormat;
  uploads?: Array<UploadWireFormat>;
}

export default class BotNote implements RenderableData {
  readonly renderableType: RenderableType = RenderableType.BotNote;
  readonly blocks: Array<object>;
  readonly adminSummary: AdminSummary;
  readonly customBotSummary?: CustomBotSummary;
  readonly uploads?: Array<Upload>;

  get entity() {
    return this.adminSummary;
  }

  get creatingEntity() {
    return {
      type: EntityType.Bot,
      id: this.adminSummary.id,
      object: this.adminSummary,
    };
  }

  get styles() {
    return {
      backgroundColor: 'bg-notice-container',
      textColor: 'text-default',
      backgroundColorHover: 'bg-notice-container-emphasis',
    };
  }

  get ticketStyles() {
    return {
      backgroundColor: 'bg-transparent',
      textColor: 'text-default',
      backgroundColorHover: 'bg-neutral-container',
    };
  }

  constructor(
    blocks: Array<object>,
    entity: AdminSummary,
    customBotSummary?: CustomBotSummary,
    uploads?: Array<Upload>,
  ) {
    this.blocks = blocks;
    this.adminSummary = entity;
    this.customBotSummary = customBotSummary;
    this.uploads = uploads || [];
  }

  static deserialize(json: BotNoteWireFormat): BotNote {
    return new BotNote(
      json.blocks,
      AdminSummary.deserialize(json.entity),
      json.custom_bot_summary ? CustomBotSummary.deserialize(json.custom_bot_summary) : undefined,
      json.uploads?.map(Upload.deserialize),
    );
  }
}
